import {
  VStack,
  HStack,
  Heading,
  Text,
  Card,
  InlineCode,
  Badge,
  Stepper,
  TableOfContents,
  Animate,
  useIsDesktop
} from 'wss3-forge'
import { Rocket20Regular } from '@fluentui/react-icons'

export function DocsHome() {
  const isDesktop = useIsDesktop()
  const baseUrl = 'https://account.webba-creative.com'

  const tocItems = [
    { id: 'intro', title: 'Comment ça marche ?' }
  ]

  return (
    <div className="page-content">
      <HStack gap="xl" style={{ alignItems: 'flex-start' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <VStack gap="xl">
            <Animate type="fadeIn">
              <VStack gap="sm" style={{ alignItems: 'flex-start' }}>
                <Badge variant="primary">Guide d'intégration</Badge>
                <Heading level={1}>Documentation Webba ID</Heading>
                <Text color="muted" size="lg">
                  Intégrez l'authentification Webba ID (WiD) dans vos applications en quelques minutes.
                </Text>
              </VStack>
            </Animate>

            <div id="intro" style={{ scrollMarginTop: '100px' }}>
              <Animate type="slideInUp" delay={100}>
                <Card padding="lg">
                  <VStack gap="md">
                    <HStack gap="sm" style={{ alignItems: 'center' }}>
                      <Rocket20Regular style={{ color: 'var(--brand-primary)' }} />
                      <Heading level={3}>Comment ça marche ?</Heading>
                    </HStack>
                    <Text>
                      Webba ID est un système d'authentification centralisé (SSO) similaire à Google ou Microsoft Account.
                      Vos utilisateurs se connectent une seule fois et peuvent accéder à toutes vos applications.
                    </Text>

                    <Stepper
                      steps={[
                        { id: '1', title: 'Votre app', description: 'Bouton de connexion' },
                        { id: '2', title: 'Webba ID', description: 'Authentification' },
                        { id: '3', title: 'Callback', description: 'Code retourné' },
                        { id: '4', title: 'Connecté', description: 'Token obtenu' }
                      ]}
                      currentStep={0}
                    />

                    <VStack gap="xs">
                      <Text><Text weight="bold" as="span">1.</Text> L'utilisateur clique sur "Se connecter avec Webba ID"</Text>
                      <Text><Text weight="bold" as="span">2.</Text> Il est redirigé vers <InlineCode>{`${baseUrl}/login`}</InlineCode></Text>
                      <Text><Text weight="bold" as="span">3.</Text> Après authentification, il revient sur votre app avec un <InlineCode>code</InlineCode></Text>
                      <Text><Text weight="bold" as="span">4.</Text> Votre serveur échange ce code contre un <InlineCode>access_token</InlineCode></Text>
                      <Text><Text weight="bold" as="span">5.</Text> Vous récupérez les informations de l'utilisateur</Text>
                    </VStack>
                  </VStack>
                </Card>
              </Animate>
            </div>
          </VStack>
        </div>

        {isDesktop && (
          <div style={{
            position: 'sticky',
            top: '2rem',
            width: '220px',
            flexShrink: 0
          }}>
            <TableOfContents
              items={tocItems}
              title="Sur cette page"
              autoTrack
              scrollOffset={100}
              variant="bordered"
            />
          </div>
        )}
      </HStack>
    </div>
  )
}
